import React, {useEffect, useState, useContext} from "react";
import AuthContext from "../context/authContext";

import {useLocation} from "react-router-dom";
import TableauDashboardListRow from "./dashboardrow";
import UserSideMenu from "./userSideMenu";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import TimeOutDialog from "./timeoutDialog";
import CheckSession from "../helpers/checkSession";

import logo from "../content/img/logo-header.png";
import logoutImg from "../content/img/exit.png";
import adminSettingImg from "../content/img/admin_settings.svg";

import "../content/base_2.0.css";
import "../content/home_2.0.css";
import TableauViz2 from "./tableauviz";

import AddEditUserModal from "./addEditUserModal";
import {UserEditAccountModal} from "./userEdtitAccount";


const TableauDashboardList = () =>{
    let navigate = useNavigate();
    const location = useLocation();
    const {logout} = useContext(AuthContext);

    const loginRslt = location.state?.loginResult;
    
    const [vizUrl, setVizUrl] = useState(''); 
    const [dashboard, setDashboard] = useState('');
    const [siteId, setSiteId] = useState('');
    const [userName, setUserName] = useState('');
    const [view, setView] = useState('');
    const [openUserEditModal, setUserEditModal] = useState(false);
    
    let hasDirectReports =  (loginRslt.user.directReportEmployees?.length > 0);
    let lr = loginRslt;
    
    CheckSession(loginRslt);

    const fakeFunc = (vizUrl, dashboard, siteId, userName, view, lr) => {
        setVizUrl(vizUrl);
        setDashboard(dashboard);
        setSiteId(siteId);
        setUserName(userName);
        setView(view);
    };

    const dashboards = location.state?.loginResult?.sitePage.allWorkbooks;
    const allReports =  dashboards?.map((d) => (<TableauDashboardListRow key={d.id} dashboard={d} fakefunc={fakeFunc} />));
    
    var sideMenu = null;
    if(allReports !== null && allReports !== undefined){
        sideMenu = <UserSideMenu loginResult={loginRslt} />;
    }
    
    function showUserSettings() {
        console.log("Show User Settings");
        if(hasDirectReports){
            navigate("/settings", {state: {id:4, name:"UserSettings", loginResult: loginRslt}});
        }else{
            setUserEditModal(true);
       }
    };

    function userLogout(){
        console.log("User clicked Logout");
        window.history.replaceState({}, '');
        logout();
        
        navigate("/", {state: {id:3, name:"LogOut", loginResult: null}, replace: true});
    };
    const TD = TimeOutDialog();

    const UserShelfDiv = () => {
        return (<>
            <img className="selectable-img" id="logout-btn" name="logout-btn" src={logoutImg} alt="Log Out" onClick={() => userLogout()}></img>
            <img className="selectable-img" id="settings-button" name="settings" alt="user settings" src={adminSettingImg} onClick={() => showUserSettings()} ></img>
        </>);
    };

    const userMenu = UserShelfDiv();

    const vizDiv = () => {
        if(vizUrl == ''){
            return(<h1 className="large">Select A Dashboard</h1>);
        }else{
            return (
                <TableauViz2  
                        vizUrl={vizUrl} 
                        dashboard={dashboard} 
                        siteId={siteId} 
                        userName={userName}
                        view={view} 
                        loginResult={lr} 
                />
            );
        }
    };
    const vd = vizDiv();

    if(loginRslt){
        return(
            <> {/* react fragment */}
            <Container className="mt-4">
                <div id="vertical-bar" name="top-bar" hidden>
                    <img id="logo" name="logo" src={logo} alt="Community Care Behavioral Health Organization"  />
                    <br /><br />
                    <hr id="menuHr" width="90%"/>
                    <br />
                    <div id="all-reports-menu" > 
                    {allReports}
                    </div>
                </div>

                <div id="user-shelf">
                    {userMenu}
                </div>

                <div id="main-body" className="print-area">
                    {vd}    
                </div>

                {TD}
            </Container>
                { openUserEditModal &&
                <UserEditAccountModal closeModal={(upUsr) => {
                    setUserEditModal(false);
                    if(upUsr !== undefined){
                        loginRslt.user = upUsr;
                    }
                }}
                    user= {loginRslt.user}
                />
            }
            </>
        );
    }
};

export default TableauDashboardList;